import { z } from 'zod';
import { menuItemZod } from './MenuItem';
import { schoolRankZod, simpleSchoolZod } from './School';
import { zodStringToDateTime } from '../utils';

export const userZod = z.object({
  account: z.string(),
  name: z.string(),
  mail: z.string().nullish(),
  // schoolId: z.string(),
  // roleId: z.string(),
});

export const yearSemZod = z.object({
  sem: z.number(),
  year: z.number(),
});

export const semesterZod = z.object({
  sem: z.number(),
  year: z.number(),
  isNow: z.boolean(),
});

export const loginResponseZod = z.object({
  token: z.string(),
  user: userZod,
  currentSchool: z.string().nullish(),
  currentRank: schoolRankZod,
  menus: z.array(menuItemZod),
  schools: z.array(simpleSchoolZod),
  semesters: z.array(semesterZod),
  currentDate: z.string(),
  exportFileType: z.number(),
  nextOTPTime: zodStringToDateTime(),
});

export const userInfoZod = z.object({
  name: z.string(),
  mail: z.string(),
  phone: z.string(),
  birth: zodStringToDateTime(),
  fax: z.string().nullish(),
  ext: z.string().nullish(),
  exportFileType: z.number(),
});

export type LoginResponse = z.infer<typeof loginResponseZod>;
export type User = z.infer<typeof userZod>;
export type YearSem = z.infer<typeof yearSemZod>;
export type Semester = z.infer<typeof semesterZod>;
export type UserInfo = z.infer<typeof userInfoZod>;
